import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const FormStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`

export const Row = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;

  > * {
    flex: 1;
    min-width: 0;
  }
`

export const BalanceHint = styled.div<{ $danger?: boolean }>`
  padding: 0.625rem 0.875rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  border: 1px solid ${(p) => (p.$danger ? tokens.status.danger.fg : tokens.border.hairline)};
  font-size: ${tokens.font.label};
  color: ${(p) => (p.$danger ? tokens.status.danger.fg : tokens.text.secondary)};
`
